module.exports = __webpack_public_path__ + "img/2015-1.df32e2aa.jpg";